export class BaseNumberModel {
  number: number;
}
